<template>
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="13" height="10">
		<g
			:style="`fill:${active ? activeColor : inactiveColor}`"
		>
			<path d="M504.502,75.496c-9.997-9.998-26.205-9.998-36.204,0L161.594,382.203L43.702,264.311c-9.997-9.998-26.205-9.997-36.204,0
				c-9.998,9.997-9.998,26.205,0,36.203l135.994,135.992c9.994,9.997,26.214,9.99,36.204,0L504.502,111.7
				C514.5,101.703,514.499,85.494,504.502,75.496z"/>
		</g>
	</svg>
</template>
<script>
export default {
	name: 'check-svg',
	props: {
		active: {
			default: false,
			type: Boolean,
		},
		activeColor: {
			default: '',
			type: String,
		},
		inactiveColor: {
			default: '',
			type: String,
		},
	},
};
</script>
<style lang="scss" scoped>
	.image {
		width: 13px;
		fill: color(secondary);
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/icons/check-component.vue